import { createContext } from 'react';
/**
 * Context providing an optional function to load a table plugin by name.
 * When provided, `useLoadTablePlugin` will call this function before falling
 * back to the built-in plugin registry lookup.
 */
export var TablePluginLoaderContext = /*#__PURE__*/createContext(null);
TablePluginLoaderContext.displayName = 'TablePluginLoaderContext';
export default TablePluginLoaderContext;
//# sourceMappingURL=TablePluginLoaderContext.js.map